import { MobileViewLayoutComponent } from './modules/mobile-view/mobile-view-layout/mobile-view-layout.component';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
import { SuccessPageComponent } from './shared/components/success-page/success-page.component';

import { DashboardLayoutComponent } from './layout/dashboard-layout/dashboard-layout/dashboard-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import { AuthGuard } from './auth-gaurd/auth.garud';
import { DASHBOARDLAYOUT_ROUTES } from './layout/dashboard-layout/dashboard-layout-routes';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'success',
    component: SuccessPageComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    component: DashboardLayoutComponent,
    // children: DASHBOARDLAYOUT_ROUTES
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'mobile',
    //canActivate: [AuthGuard],
    component: MobileViewLayoutComponent,
    // children: DASHBOARDLAYOUT_ROUTES
    loadChildren: () =>
      import('./modules/mobile-view/mobile-view.module').then(
        (m) => m.MobileViewModule
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
